import { ChevronsUpDown, Copy, EllipsisVertical, FolderOutput, Loader, MailCheck, MailPlus, Replace, Trash2, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import DeleteModal from "../Modal/DeleteModal";
import { can_visit, exchangeDate } from "../../helpers";
import Badge from "../UI/Badge";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function RejectionTrackerDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    reloadData = () => {},
    reloadOverviewData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    handleDeleteRecord = () => {},
    checkSelected = false,
    exportData = () => {},
    exportButtonLoader = false,
    rejectionEdit = false,
    setRejectionEdit = () => {},
    rejectionCopy = false,
    setRejectionCopy = () => {},
    setSelectedReferral = {},
    changeStatus = () => {},
    rejectionBulkDelete = false,
    setRejectionBulkDelete = () => {},
    handleNotifyPractice = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
    checkedIds = [],
    setCheckedIds = () => {},
    globalCheckedIds,
    setGlobalCheckedIds,
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [viewStatusOptions2, setViewStatusOptions2] = useState({});
  const [deleteRecord, setDeleteRecord] = useState({});
  const [activeDeleteModal, setActiveDeleteModal] = useState(false);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    reloadOverviewData();
    setDataLoading(true);
  };

  const handleDropdownClick = (index) => {
    setViewStatusOptions2({});
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const handleDropdownClick2 = (index) => {
    setViewStatusOptions({});
    setViewStatusOptions2((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
      setViewStatusOptions2({});
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const LimitText = ({ text, limit }) => {
    if (text?.length <= limit) {
      return text;
    } else {
      const limitText = text?.substring(0, limit) + "...";
      return limitText;
    }
  };

  const removeSelection = () => {
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  return (
    <>
      {checkSelected && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {(can_visit("rejection_tracker") && can_visit('_bulk_export')) && (
              <button 
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={exportData}
                disabled = {exportButtonLoader ? true : false}
              >
                <FolderOutput width={20} height={20} />
                Export
                {exportButtonLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            )}
            {(can_visit("rejection_tracker") && can_visit('rejection_tracker_delete')) && (
              <button className="docpro_bordered_btn docpro_fw_600 docpro_red_color"
                onClick={() => {
                  setRejectionBulkDelete(!rejectionBulkDelete);
                  setPreviousScrollPosition(window.scrollY);
                  window.scrollTo(0, 0);
                }}
              >
                <Trash2 width={20} height={20} />
                Delete
              </button>
            )}

            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Rejections</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  <X width={18} height={18} />
                </button>
              </div>
            )}
          </div>
        </>
      )}

      <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '330px' }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={() => handleSelectAll(tableData)}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("billing_id");
                  }}
                  className={
                    orderBy === "billing_id" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Billing ID <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("dos");
                  }}
                  className={
                    orderBy === "dos" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    DOS <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("last_name");
                  }}
                  className={
                    orderBy === "last_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Last Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("first_name");
                  }}
                  className={
                    orderBy === "first_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    First Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("insurance_name");
                  }}
                  className={
                    orderBy === "insurance_name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Insurance <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("issue");
                  }}
                  className={
                    orderBy === "issue" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Issues <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("note");
                  }}
                  className={
                    orderBy === "note" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Note <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("resubmit_date");
                  }}
                  className={
                    orderBy === "resubmit_date" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Resubmit Date <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("after_resub_paid");
                  }}
                  className={
                    orderBy === "after_resub_paid" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    After Resub <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("status");
                  }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>
                    Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`${index}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.billing_id}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {exchangeDate(item?.dos)}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.last_name}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.first_name}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.insurance_name}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <LimitText text={item?.issue} limit={20} />
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <LimitText text={item?.note} limit={26} />
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {exchangeDate(item?.resubmit_date)}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.after_resub_paid ? !isNaN(item?.after_resub_paid) ? `$${item.after_resub_paid}` : item?.after_resub_paid: ''}
                    </td>
                    <td className="pointer"
                      onClick={() => { 
                        setSelectedReferral(item); 
                        setRejectionEdit(!rejectionEdit);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.status === "Pending" && (
                        <Badge color="orange">Pending</Badge>
                      )}
                      {item?.status === "Paid" && (
                        <Badge color="green">Paid</Badge>
                      )}
                      {item?.status === "Resubmitted" && (
                        <Badge color="cyan">Resubmitted</Badge>
                      )}
                      {item?.status === "Again denied" && (
                        <Badge color="orange">Again denied</Badge>
                      )}
                      {item?.status === "Need clinic’s help" && (
                        <Badge color="red">Need clinic’s help</Badge>
                      )}
                      {item?.status === "Write off" && (
                        <Badge color="olive">Write off</Badge>
                      )}
                    </td>
                    <td className="docpro_text_center">
                      <div className="docpro_icon_btns">
                        {(can_visit("rejection_tracker") && can_visit('rejection_tracker_status')) && (
                          <div className="dropdown-container" style={{ position: 'relative' }}>
                            <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                              <Replace width={18} height={18} />
                              <span className="docpro_tip">Change Status</span>
                            </button>
                            {viewStatusOptions[index] && (
                              <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                                <p onClick={() => {changeStatus(item?.id, 'Again denied'); setViewStatusOptions({})}}>Again denied</p>
                                <p onClick={() => {changeStatus(item?.id, 'Need clinic’s help'); setViewStatusOptions({})}}>Need clinic’s help</p>
                                <p onClick={() => {changeStatus(item?.id, 'Paid'); setViewStatusOptions({})}}>Paid</p>
                                <p onClick={() => {changeStatus(item?.id, 'Pending'); setViewStatusOptions({})}}>Pending</p>
                                <p onClick={() => {changeStatus(item?.id, 'Resubmitted'); setViewStatusOptions({})}}>Resubmitted</p>
                                <p onClick={() => {changeStatus(item?.id, 'Write off'); setViewStatusOptions({})}}>Write off</p>
                              </div>
                            )}
                          </div>
                        )}

                        <div className="dropdown-container relative">
                          <button className="docpro_icon_btn" onClick={() => handleDropdownClick2(index)}>
                            <EllipsisVertical width={18} height={18} />
                          </button>
                          {viewStatusOptions2[index] && (
                            <div className={`docpro_button_toggle_options ${index > 4 && 'top_position'}`}>
                              {/* <button type="button" className={`docpro_icon_btn docpro_dropdown_button`}
                                onClick={() => handleNotifyPractice(item?.id)}
                              >
                                {item?.is_complete === true ?
                                  <>
                                    <MailCheck width={18} height={18} className="docpro_green_color" />
                                    <span>Already Sended</span>
                                  </>
                                :
                                  <>
                                    <MailPlus width={18} height={18} className="docpro_orange_color" />
                                    <span>Send Notify Email</span>
                                  </>
                                }
                              </button> */}
                              <button type="button" className="docpro_icon_btn docpro_dropdown_button"
                                onClick={() => { 
                                  setSelectedReferral(item); 
                                  setRejectionCopy(!rejectionCopy);
                                  setPreviousScrollPosition(window.scrollY);
                                  window.scrollTo(0, 0);
                                }}
                              >
                                <Copy width={18} height={18} />
                                <span>Copy</span>
                              </button>
                              {(can_visit("rejection_tracker") && can_visit('rejection_tracker_delete')) && (
                                <button
                                  className="docpro_icon_btn docpro_dropdown_button docpro_icon_btn_red"
                                  onClick={() => {
                                    setDeleteRecord(item);
                                    setActiveDeleteModal(true);
                                    setPreviousScrollPosition(window.scrollY);
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  <Trash2 width={18} height={18} />
                                  <span>Delete</span>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "330px" }} colSpan="12">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2.2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3.2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 4)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="4rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${6 + (index % 3.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-right"> <span className="mr-4 pr-2"><Skeleton width="3rem" borderRadius="8px"></Skeleton></span> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeDeleteModal && (
        <DeleteModal
          handleDelete={() => handleDeleteRecord(deleteRecord?.id)}
          name={deleteRecord?.last_name + ' ' + deleteRecord?.first_name}
          activeModal={activeDeleteModal}
          setActiveModal={setActiveDeleteModal}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      )}
    </>
  );
}
